import { client } from "../../infrastructure/graphql/client";
import {
  GET_TOTAL_COSTS_BY_SERVICE,
  GET_TOTAL_COSTS_BY_METER,
  GET_SHARED_COSTS_BY_SERVICE,
  GET_COSTS_BY_SERVICE_NAME,
} from "../../infrastructure/graphql/groupedCostQueries";

export class GroupedCostsService {
  async getTotalCostsByService(year, month) {
    try {
      const result = await client.query({
        query: GET_TOTAL_COSTS_BY_SERVICE,
        variables: { year, month },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getTotalCostsByService;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get total costs by service error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async getTotalCostsByMeter(year, month) {
    try {
      const result = await client.query({
        query: GET_TOTAL_COSTS_BY_METER,
        variables: { year, month },
        fetchPolicy: "network-only",
      });

      const response = result.data?.getTotalCostsByMeter;

      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error("Get total costs by meter error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return {
        success: false,
        message: errorMessage,
        data: null,
      };
    }
  }

  async getSharedCostsByService(year, month) {
    try {
      const result = await client.query({
        query: GET_SHARED_COSTS_BY_SERVICE,
        variables: { year, month },
        fetchPolicy: "network-only",
      });
      const response = result.data?.getSharedCostsByService;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, data: response };
    } catch (error) {
      console.error("Get shared costs by service error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }

  async getCostsByServiceName(startDate, endDate, serviceName) {
    try {
      const result = await client.query({
        query: GET_COSTS_BY_SERVICE_NAME,
        variables: { startDate, endDate, serviceName },
        fetchPolicy: "network-only",
      });
      const response = result.data?.getCostsByServiceName;
      if (!response) {
        return {
          success: false,
          message: "No response from server",
          data: null,
        };
      }
      return { success: true, data: response };
    } catch (error) {
      console.error("Get costs by service name error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage, data: null };
    }
  }
}